<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-settings">{{
              $t("dashboardCardSuperAdminOther")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <v-form ref="form" v-model="valid">
              <!-- basicSettings -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  {{ $t("settingsOtherBasicSettingsCardTitle") }}
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.fullName"
                        :label="$t('settingsOtherFullNameTitle')"
                        :rules="[validateRequired(), validateMaxLength(50)]"
                        :counter="50"
                        dense
                      ></v-text-field>
                      <v-textarea
                        class="mb-3"
                        v-model="editedItem.companyInfo"
                        :label="$t('settingsOtherCompanyInfoTitle')"
                        :hint="$t('settingsOtherCompanyInfoHintTitle')"
                        :rules="[validateRequired(), validateMaxLength(350)]"
                        :counter="350"
                        dense
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- environmentSettings -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  {{ $t("settingsOtherEnvironmentSettingsCardTitle") }}
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select
                        item-text="title"
                        item-value="langShort"
                        :items="flagItems"
                        v-model="editedItem.lang"
                        :label="$t('settingsOtherLangTitle')"
                        dense
                      ></v-select>
                      <v-select
                        item-text="title"
                        item-value="title"
                        :items="currencyItems"
                        v-model="editedItem.currency"
                        :label="$t('settingsOtherCurrencyCardTitle')"
                        dense
                      ></v-select>
                      <v-text-field
                        v-model="editedItem.taxTitle"
                        :label="$t('settingsOtherTaxTitle')"
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                      <v-select
                        item-text="title"
                        item-value="nfShort"
                        :items="numberFormatItems"
                        v-model="editedItem.numberFormat"
                        :label="$t('settingsOtherNumberFormatTitle')"
                        dense
                      ></v-select>
                      <v-text-field
                        class="pa-0 ma-0"
                        v-model="editedItem.digits"
                        single-line
                        type="number"
                        :hint="$t('settingsOtherDigitsTitle')"
                        :label="$t('settingsOtherDigitsTitle')"
                      />
                      <v-text-field
                        v-model="editedItem.dateFormat"
                        single-line
                        :hint="$t('settingsOtherDateFormatTitle')"
                        :label="$t('settingsOtherDateFormatTitle')"
                        :rules="[validateRequired(), validateMaxLength(20)]"
                        :counter="20"
                        dense
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- prepaySettings -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  {{ $t("settingsOtherPrepaySettingsCardTitle") }}
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-textarea
                        class="mb-3"
                        v-model="editedItem.prepayInfo"
                        :label="$t('settingsOtherCompanyInfoTitle')"
                        :hint="$t('settingsOtherCompanyInfoHintTitle')"
                        :rules="[validateRequired(), validateMaxLength(500)]"
                        :counter="500"
                        dense
                      ></v-textarea>
                      <v-switch
                        class="ma-0 pa-0"
                        style="height: 50px"
                        v-model="editedItem.enableQRCode"
                        :label="$t('settingsOtherOrderEnableQRCodeTitle')"
                        dense
                      ></v-switch>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.qrCompanyTitle"
                        :label="$t('settingsOtherCompanyInfoTitleTitle')"
                        :rules="[validateRequired(), validateMaxLength(33)]"
                        :counter="33"
                        dense
                      ></v-text-field>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.qrCompanyAddress1"
                        :label="$t('settingsOtherCompanyInfoAddress1Title')"
                        :rules="[validateRequired(), validateMaxLength(33)]"
                        :counter="33"
                        dense
                      ></v-text-field>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.qrCompanyAddress2"
                        :label="$t('settingsOtherCompanyInfoAddress2Title')"
                        :rules="[validateRequired(), validateMaxLength(33)]"
                        :counter="33"
                        dense
                      ></v-text-field>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.qrCompanyAccount"
                        :label="$t('settingsOtherCompanyInfoAccountTitle')"
                        :rules="[validateRequired(), validateMaxLength(34)]"
                        :counter="34"
                        dense
                      ></v-text-field>
                      <v-select
                        item-text="title"
                        item-value="qrShort"
                        :items="qrCodeFormatItems"
                        v-model="editedItem.qrCodeFormat"
                        :label="$t('settingsOtherQRCodeFormatTitle')"
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- orderPrintSettings -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  {{ $t("settingsOtherOrderPrintSettingsCardTitle") }}
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <!--<v-select
                        item-text="title"
                        item-value="langShort"
                        :items="orderPrintFonts"
                        v-model="editedItem.font"
                        :label="$t('settingsOtherOrderPrintFontTitle')"
                        dense
                      ></v-select>-->
                      <v-text-field
                        class="pa-0 ma-0"
                        v-model="editedItem.fontSize"
                        single-line
                        type="number"
                        :hint="$t('settingsOtherOrderPrintFontSizeTitle')"
                        :label="$t('settingsOtherOrderPrintFontSizeTitle')"
                      />
                      <v-text-field
                        class="pa-0 ma-0"
                        v-model="editedItem.printWidth"
                        single-line
                        type="number"
                        :hint="$t('settingsOtherOrderPrintMaxWidthTitle')"
                        :label="$t('settingsOtherOrderPrintMaxWidthTitle')"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- responseSettings -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  {{ $t("settingsOtherResponseSettingsCardTitle") }}
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <!-- New order tiptap -->
                    <v-flex xs12>
                      <v-btn
                        text
                        color="primary"
                        fab
                        small
                        @click="setTipTapContent('newOrderMsg')"
                      >
                        <v-icon>mdi-water-off</v-icon>
                      </v-btn>
                      {{ $t("settingsOtherNewOrderMsgTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <tiptap-vuetify
                        v-model="editedItem.newOrderMsg"
                        :extensions="extensions"
                        :card-props="{ flat: true, color: '#e1e1e1' }"
                        :placeholder="$t('msgNoText')"
                      />
                    </v-flex>
                    <!-- New order prepay tiptap -->
                    <v-flex class="mt-4" xs12>
                      <v-btn
                        text
                        color="primary"
                        fab
                        small
                        @click="setTipTapContent('newOrderPrepayMsg')"
                      >
                        <v-icon>mdi-water-off</v-icon>
                      </v-btn>
                      {{ $t("settingsOtherNewOrderPrepayMsgTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <tiptap-vuetify
                        v-model="editedItem.newOrderPrepayMsg"
                        :extensions="extensions"
                        :card-props="{ flat: true, color: '#e1e1e1' }"
                        :placeholder="$t('msgNoText')"
                      />
                    </v-flex>
                    <!-- Order completed personal delivery tiptap -->
                    <v-flex class="mt-4" xs12>
                      <v-btn
                        text
                        color="primary"
                        fab
                        small
                        @click="setTipTapContent('orderCompletedPersonal')"
                      >
                        <v-icon>mdi-water-off</v-icon>
                      </v-btn>
                      {{ $t("settingsOtherOrderCompletedPersonalTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <tiptap-vuetify
                        v-model="editedItem.orderCompletedPersonal"
                        :extensions="extensions"
                        :card-props="{ flat: true, color: '#e1e1e1' }"
                        :placeholder="$t('msgNoText')"
                      />
                    </v-flex>
                    <!-- Order completed post delivery tiptap -->
                    <v-flex class="mt-4" xs12>
                      <v-btn
                        text
                        color="primary"
                        fab
                        small
                        @click="setTipTapContent('orderCompletedPost')"
                      >
                        <v-icon>mdi-water-off</v-icon>
                      </v-btn>
                      {{ $t("settingsOtherOrderCompletedPostTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <tiptap-vuetify
                        v-model="editedItem.orderCompletedPost"
                        :extensions="extensions"
                        :card-props="{ flat: true, color: '#e1e1e1' }"
                        :placeholder="$t('msgNoText')"
                      />
                    </v-flex>
                    <!-- Cart expire tiptap -->
                    <v-flex class="mt-4" xs12>
                      <v-btn
                        text
                        color="primary"
                        fab
                        small
                        @click="setTipTapContent('cartItemExpire')"
                      >
                        <v-icon>mdi-water-off</v-icon>
                      </v-btn>
                      {{ $t("settingsOtherCartExpireResponseTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <tiptap-vuetify
                        v-model="editedItem.cartItemExpire"
                        :extensions="extensions"
                        :card-props="{ flat: true, color: '#e1e1e1' }"
                        :placeholder="$t('msgNoText')"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- loginSettings -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  {{ $t("settingsOtherLoginSettingsCardTitle") }}
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-switch
                        class="ma-0 pa-0"
                        style="height: 50px"
                        v-model="editedItem.loginImage"
                        :label="$t('settingsOtherLoginImageTitle')"
                        dense
                      ></v-switch>
                      <v-text-field
                        v-show="editedItem.loginImage"
                        class="mb-3"
                        v-model="editedItem.loginImageKeyword"
                        :label="$t('settingsOtherLoginImageKeywordTitle')"
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                      <v-file-input
                        v-bind:clearable="false"
                        v-show="!editedItem.loginImage"
                        accept="image/jpeg"
                        prepend-icon="mdi-camera"
                        append-icon="mdi-close"
                        @change="fileLoginImageStorageLinkChange()"
                        @click:append="fileLoginImageStorageLinkRemove()"
                        v-model="fileLoginImageStorageLink"
                        class="mb-3 mt-0 pa-0"
                        :label="$t('settingsOtherLoginImageStorageLinkTitle')"
                      ></v-file-input>
                      <v-img
                        v-show="!editedItem.loginImage"
                        :src="
                          editedItem.loginImageStorageLink.length > 0
                            ? getLoginImageStorageLink
                            : loginMainCardImage
                        "
                        class="mb-6"
                        style="max-width: 400px"
                      ></v-img>
                      <v-file-input
                        v-bind:clearable="false"
                        accept="image/x-png"
                        prepend-icon="mdi-camera"
                        append-icon="mdi-close"
                        @change="fileLogoImageStorageLinkChange()"
                        @click:append="fileLogoImageStorageLinkRemove()"
                        v-model="fileLogoImageStorageLink"
                        class="mb-3 mt-0 pa-0"
                        :label="$t('settingsOtherLogoImageStorageLinkTitle')"
                      ></v-file-input>
                      <v-img
                        :src="
                          editedItem.logoImage.length > 0
                            ? getLogoImageStorageLink
                            : defaultAppLogo
                        "
                        class="mb-6"
                        style="max-width: 60px"
                      ></v-img>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.clientPunchline"
                        :label="$t('settingsOtherClientPunchlineTitle')"
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                      <v-textarea
                        v-model="editedItem.loginBackgroundWelcomeMessage"
                        :label="
                          $t('settingsOtherLoginBackgroundWelcomeMessageTitle')
                        "
                        :rules="[validateMaxLength(250)]"
                        :counter="250"
                        dense
                      ></v-textarea>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.loginBackgroundColor"
                        :label="$t('settingsOtherLoginBackgroundColorTitle')"
                        :rules="[validateMaxLength(50)]"
                        :counter="50"
                        dense
                      ></v-text-field>
                      <v-switch
                        class="ma-0 pa-0"
                        v-model="editedItem.loginBackgroundImage"
                        :label="$t('settingsOtherLoginBackgroundImageTitle')"
                        dense
                      ></v-switch>
                      <v-text-field
                        v-show="editedItem.loginBackgroundImage"
                        class="mb-3"
                        v-model="editedItem.loginBackgroundImageKeyword"
                        :label="
                          $t('settingsOtherLoginBackgroundImageKeywordTitle')
                        "
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                      <v-slider
                        v-model="editedItem.loginBackgroundShadowType"
                        style="max-width: 500px"
                        max="255"
                        min="0"
                        tick-size="1"
                        :track-color="setRGBAColor"
                        :track-fill-color="setRGBAColor"
                        :label="
                          $t('settingsOtherLoginBackgroundShadowTypeTitle')
                        "
                        dense
                      ></v-slider>
                      <v-slider
                        v-model="editedItem.loginBackgroundShadowStrength"
                        style="max-width: 500px"
                        max="100"
                        min="0"
                        tick-size="1"
                        :track-color="setRGBAShadow"
                        :track-fill-color="setRGBAShadow"
                        :label="
                          $t('settingsOtherLoginBackgroundShadowStrengthTitle')
                        "
                        dense
                      ></v-slider>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- rulesAndSecurityInfo -->
              <v-card
                class="#505050--text mb-12"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  {{ $t("settingsOtherRulesAndSecurityInfoCardTitle") }}
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <!-- GDPR settings -->
                    <v-switch
                      class="ma-0 pa-0"
                      style="height: 30px"
                      v-model="editedItem.showPrivacyInfo"
                      :label="$t('settingsOtherShowPrivacyInfoTitle')"
                      dense
                    ></v-switch>
                    <v-flex xs12>
                      {{ $t("settingsOtherPrivacyHTMLTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea flat v-model="editedItem.privacyHTML">
                      </v-textarea>
                    </v-flex>
                    <!-- Terms of use settings -->
                    <v-switch
                      class="ma-0 pa-0 mt-8"
                      style="height: 30px"
                      v-model="editedItem.showRulesInfo"
                      :label="$t('settingsOtherShowRulesInfoTitle')"
                      dense
                    ></v-switch>
                    <v-flex xs12>
                      {{ $t("settingsOtherRulesHTMLTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea flat v-model="editedItem.rulesHTML">
                      </v-textarea>
                    </v-flex>
                    <!-- Cookies settings -->
                    <v-switch
                      class="ma-0 pa-0 mt-8"
                      style="height: 50px"
                      v-model="editedItem.showCookiesInfo"
                      :label="$t('settingsOtherShowCookiesInfoTitle')"
                      dense
                    ></v-switch>
                    <v-flex xs12>
                      {{ $t("settingsOtherCookiesHTMLTitle") }}
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea flat v-model="editedItem.cookiesHTML">
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
          <!-- GUMB NAZAJ -->
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenu' })"
          ></simple-navigation-button>
          <!-- GUMB SHRANI -->
          <simple-navigation-button
            right
            :title="$t('addEditFormSaveButton')"
            icon="mdi-content-save"
            @clicked="saveOther"
          ></simple-navigation-button>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import { storage } from "@/firebase";
import { flagLang } from "@/localization/flagLang";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  name: "settingsOther",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    TiptapVuetify,
    SimpleNavigationButton,
  },
  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3, 4, 5, 6],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      valid: true,
      defaultAppLogo: require("@/assets/defaultAppLogo.png"),
      netBackImage: require("@/assets/netBack.png"),
      loginMainCardImage: require("@/assets/photoOrderLogin.jpg"),
      flagItems: flagLang,
      orderPrintFonts: ["TimesNewRoman"],
      editedItem: {
        fullName: this.$store.state.storeClient.client.basicSettings.fullName,
        cartItemExpire:
          this.$store.state.storeClient.client.responseSettings.cartItemExpire,
        newOrderMsg:
          this.$store.state.storeClient.client.responseSettings.newOrderMsg,
        newOrderPrepayMsg:
          this.$store.state.storeClient.client.responseSettings
            .newOrderPrepayMsg,
        orderCompletedPersonal:
          this.$store.state.storeClient.client.responseSettings
            .orderCompletedPersonal,
        orderCompletedPost:
          this.$store.state.storeClient.client.responseSettings
            .orderCompletedPost,
        companyInfo:
          this.$store.state.storeClient.client.basicSettings.companyInfo,
        prepayInfo:
          this.$store.state.storeClient.client.prepaySettings.prepayInfo,
        enableQRCode:
          this.$store.state.storeClient.client.prepaySettings.enableQRCode,
        qrCompanyTitle:
          this.$store.state.storeClient.client.prepaySettings.qrCompanyTitle,
        qrCompanyAddress1:
          this.$store.state.storeClient.client.prepaySettings.qrCompanyAddress1,
        qrCompanyAddress2:
          this.$store.state.storeClient.client.prepaySettings.qrCompanyAddress2,
        qrCompanyAccount:
          this.$store.state.storeClient.client.prepaySettings.qrCompanyAccount,
        qrCodeFormat:
          this.$store.state.storeClient.client.prepaySettings.qrCodeFormat,
        clientPunchline:
          this.$store.state.storeClient.client.loginSettings.clientPunchline,
        lang: this.$store.state.storeClient.client.environmentSettings.lang,
        currency:
          this.$store.state.storeClient.client.environmentSettings.currency,
        numberFormat:
          this.$store.state.storeClient.client.environmentSettings.numberFormat,
        taxTitle:
          this.$store.state.storeClient.client.environmentSettings.taxTitle,
        digits: this.$store.state.storeClient.client.environmentSettings.digits,
        dateFormat:
          this.$store.state.storeClient.client.environmentSettings.dateFormat,
        client: this.$store.state.storeClient.client.basicSettings.name,
        loginBackgroundWelcomeMessage:
          this.$store.state.storeClient.client.loginSettings.welcomeMessage,
        loginBackgroundColor:
          this.$store.state.storeClient.client.loginSettings.background.color,
        loginBackgroundImage:
          this.$store.state.storeClient.client.loginSettings.background.image,
        loginBackgroundShadowType:
          this.$store.state.storeClient.client.loginSettings.background
            .shadowType,
        loginBackgroundShadowStrength:
          this.$store.state.storeClient.client.loginSettings.background
            .shadowStrength,
        loginBackgroundImageKeyword:
          this.$store.state.storeClient.client.loginSettings.background
            .imageKeyword,
        loginImage: this.$store.state.storeClient.client.loginSettings.image,
        loginImageKeyword:
          this.$store.state.storeClient.client.loginSettings.imageKeyword,
        loginImageStorageLink:
          this.$store.state.storeClient.client.loginSettings.imageStorageLink,
        logoImage: this.$store.state.storeClient.client.loginSettings.logoLink,
        font: this.$store.state.storeClient.client.orderPrintSettings.font,
        fontSize: this.$store.state.storeClient.client.orderPrintSettings.size,
        printWidth:
          this.$store.state.storeClient.client.orderPrintSettings.width,
        showCookiesInfo:
          this.$store.state.storeClient.client.rulesAndSecurityInfo
            .showCookiesInfo,
        showPrivacyInfo:
          this.$store.state.storeClient.client.rulesAndSecurityInfo
            .showPrivacyInfo,
        showRulesInfo:
          this.$store.state.storeClient.client.rulesAndSecurityInfo
            .showRulesInfo,
        privacyHTML:
          this.$store.state.storeClient.client.rulesAndSecurityInfo.privacyHTML,
        rulesHTML:
          this.$store.state.storeClient.client.rulesAndSecurityInfo.rulesHTML,
        cookiesHTML:
          this.$store.state.storeClient.client.rulesAndSecurityInfo.cookiesHTML,
      },
      fileLoginImageStorageLink: [],
      fileLogoImageStorageLink: [],
    };
  },
  computed: {
    getLogoImageStorageLink() {
      return this.editedItem.logoImage;
    },
    getLoginImageStorageLink() {
      return this.editedItem.loginImageStorageLink;
    },
    setRGBAColor() {
      return (
        "rgba(" +
        this.editedItem.loginBackgroundShadowType +
        ", " +
        this.editedItem.loginBackgroundShadowType +
        ", " +
        this.editedItem.loginBackgroundShadowType +
        ", 1)"
      );
    },
    setRGBAShadow() {
      return (
        "rgba(0, 0, 0, " +
        Number(this.editedItem.loginBackgroundShadowStrength / 100) +
        ")"
      );
    },
  },
  methods: {
    setTipTapContent(item) {
      if (item == "newOrderMsg") {
        this.editedItem.newOrderMsg = this.$t("userCashierEmailNewOrderStart");
      } else if (item == "newOrderPrepayMsg") {
        this.editedItem.newOrderPrepayMsg = this.$t(
          "userCashierEmailNewOrderPrepayStart"
        );
      } else if (item == "orderCompletedPersonal") {
        this.editedItem.orderCompletedPersonal = this.$t(
          "userCashierEmailOrderCompletedPersonalDelivery"
        );
      } else if (item == "orderCompletedPost") {
        this.editedItem.orderCompletedPost = this.$t(
          "userCashierEmailOrderCompletedPostDelivery"
        );
      } else if (item == "cartItemExpire") {
        this.editedItem.cartItemExpire = this.$t(
          "settingsOtherCartExpireResponse"
        );
      }
    },
    fileLoginImageStorageLinkChange() {
      //console.log(this.fileLoginImageStorageLink);
      if (this.fileLoginImageStorageLink != null) {
        let uploadPath =
          "clientCustomData/" +
          this.$store.state.storeClient.client.basicSettings.name +
          "MainLoginImage.jpg";
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(this.fileLoginImageStorageLink);
        let vm = this;
        let theURL = "";

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                theURL = downloadURL;
                vm.$store.dispatch("saveSettingsCustomLoginImageFile", {
                  loginSettings: {
                    imageStorageLink: theURL,
                  },
                });
                vm.editedItem.loginImageStorageLink = theURL;
              });
          },
        });
      } else {
        this.$store.dispatch("saveSettingsCustomLoginImageFile", {
          loginSettings: {
            imageStorageLink: "",
          },
        });
        this.editedItem.loginImageStorageLink = "";
      }
    },
    fileLoginImageStorageLinkRemove() {
      this.$store.dispatch("saveSettingsCustomLoginImageFile", {
        loginSettings: {
          imageStorageLink: "",
        },
      });
      this.editedItem.loginImageStorageLink = "";
    },
    fileLogoImageStorageLinkChange() {
      //console.log(this.fileLoginImageStorageLink);
      if (this.fileLogoImageStorageLink != null) {
        let uploadPath =
          "clientCustomData/" +
          this.$store.state.storeClient.client.basicSettings.name +
          "MainLogoImage.png";
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(this.fileLogoImageStorageLink);
        let vm = this;
        let theURL = "";

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                theURL = downloadURL;
                vm.$store.dispatch("saveSettingsCustomLogoImageFile", {
                  loginSettings: {
                    logoLink: theURL,
                  },
                });
                vm.editedItem.logoImage = theURL;
              });
          },
        });
      } else {
        this.$store.dispatch("saveSettingsCustomLogoImageFile", {
          loginSettings: {
            logoLink: "",
          },
        });
        this.editedItem.logoLink = "";
      }
    },
    fileLogoImageStorageLinkRemove() {
      this.$store.dispatch("saveSettingsCustomLogoImageFile", {
        loginSettings: {
          logoLink: "",
        },
      });
      this.editedItem.logoLink = "";
    },
    async saveOther() {
      if (this.$refs.form.validate()) {
        try {
          let result = await this.$store.dispatch("saveSettingsOther", {
            basicSettings: {
              fullName: this.editedItem.fullName,
              companyInfo: this.editedItem.companyInfo,
              name: this.$store.state.storeClient.client.basicSettings.name,
            },
            loginSettings: {
              background: {
                color: this.editedItem.loginBackgroundColor,
                image: this.editedItem.loginBackgroundImage,
                imageKeyword: this.editedItem.loginBackgroundImageKeyword,
                shadowStrength: this.editedItem.loginBackgroundShadowStrength,
                shadowType: this.editedItem.loginBackgroundShadowType,
              },
              image: this.editedItem.loginImage,
              imageKeyword: this.editedItem.loginImageKeyword,
              welcomeMessage: this.editedItem.loginBackgroundWelcomeMessage,
              clientPunchline: this.editedItem.clientPunchline,
            },
            environmentSettings: {
              lang: this.editedItem.lang,
              currency: this.editedItem.currency,
              numberFormat: this.editedItem.numberFormat,
              taxTitle: this.editedItem.taxTitle,
              digits: Number(this.editedItem.digits),
              dateFormat: this.editedItem.dateFormat,
            },
            prepaySettings: {
              prepayInfo: this.editedItem.prepayInfo,
              enableQRCode: this.editedItem.enableQRCode,
              qrCompanyTitle: this.editedItem.qrCompanyTitle,
              qrCompanyAddress1: this.editedItem.qrCompanyAddress1,
              qrCompanyAddress2: this.editedItem.qrCompanyAddress2,
              qrCompanyAccount: this.editedItem.qrCompanyAccount,
              qrCodeFormat: this.editedItem.qrCodeFormat,
            },
            responseSettings: {
              cartItemExpire: this.editedItem.cartItemExpire,
              newOrderMsg: this.editedItem.newOrderMsg,
              newOrderPrepayMsg: this.editedItem.newOrderPrepayMsg,
              orderCompletedPersonal: this.editedItem.orderCompletedPersonal,
              orderCompletedPost: this.editedItem.orderCompletedPost,
            },
            orderPrintSettings: {
              font: this.editedItem.font,
              size: this.editedItem.fontSize,
              width: this.editedItem.printWidth,
            },
            rulesAndSecurityInfo: {
              showCookiesInfo: this.editedItem.showCookiesInfo,
              showPrivacyInfo: this.editedItem.showPrivacyInfo,
              showRulesInfo: this.editedItem.showRulesInfo,
              privacyHTML: this.editedItem.privacyHTML,
              rulesHTML: this.editedItem.rulesHTML,
              cookiesHTML: this.editedItem.cookiesHTML,
            },
          });
          if (result) {
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } else {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("msgErrorSave"),
            });
          }
        } catch (error) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: error,
          });
        }
      }
    },
  },
};
</script>
<style>
.tiptap-vuetify-editor .ProseMirror {
  max-height: 200px;
}
</style>
